import {sendRequest, urls} from '../../apiRequestService';
import {IActionData} from '../../apiRequestService/types';
import {requestMethod, responseType} from '../../globalConstants';

export const getAnalyticsKpi = (data: IActionData) => {
    return sendRequest(urls.ANALYTIC_FINANCE, requestMethod.GET, responseType.JSON, data);
};
